<template>
  <w-icon-wrapper
    :height='24'
    :width='16'
    icon-name='work-mobile-phone-icon'
    view-box='0 0 16 24'
  >
    <g
      id="Gruppe_25628"
      data-name="Gruppe 25628"
    >
      <path
        id="Pfad_55852"
        data-name="Pfad 55852"
        d="M14.038,24H1.962A1.964,1.964,0,0,1,0,22.038V1.962A1.964,1.964,0,0,1,1.962,0H14.038A1.964,1.964,0,0,1,16,1.962V22.038A1.964,1.964,0,0,1,14.038,24M14,1.962,1.962,2,2,22.038,14,22Z"
        fill="currentColor"
      />
      <path
        id="Pfad_55853"
        data-name="Pfad 55853"
        d="M9,20a1,1,0,1,1-1-1,1,1,0,0,1,1,1"
        fill="currentColor"
      />
      <rect
        id="Rechteck_4058"
        data-name="Rechteck 4058"
        width="10"
        height="15"
        transform="translate(3 3)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconMobilePhone' };
</script>
